<template>
    <div class="mt-3">
        <div class="font-italic">
            Filter
            <span class="font-12">
                <i class="fal fa-filter"></i>
            </span>
        </div>
        <div v-for="(filter, idx) in filters" class="pl-3 pt-1 border-left mt-2">
            <div>
                <label>Field</label>
                <multiselect
                    :value="filter.field"
                    :options="fields"
                    @select="v => onFilterFieldSelect(idx, v)"
                    placeholder="Select field">
                </multiselect>
            </div>
            <template v-if="filter.field">
                <div class="mt-2">
                    <label>Operator</label>
                    <multiselect
                        :value="selectFilterOperators.find(o => o.key === filter.operator)"
                        :options="selectFilterOperators"
                        @select="v => onFilterOperatorSelect(idx, v)"
                        track-by="key"
                        label="label"
                        placeholder="Select operator">
                    </multiselect>
                </div>
                <div v-if="filter.operator" class="mt-2">
                    <label>Value</label>
                    <input
                        v-if="[FieldEditorOptionsFilterOperators.CONTAINS, FieldEditorOptionsFilterOperators.NOT_CONTAINS].includes(filter.operator)"
                        :value="filter.value"
                        @change="e => onFilterValueChange(idx, e.target.value)"
                        placeholder="Enter value"
                        class="form-control form-control-sm"/>
                    <multiselect
                        v-else
                        :value="filter.value"
                        :options="options.map(o => o[filter.field])"
                        @input="v => onFilterValueChange(idx, v)"
                        @search-change="fetchOptions"
                        :internal-search="false"
                        :loading="isOptionsFetching"
                        multiple
                        placeholder="Select values">
                    </multiselect>
                </div>
            </template>
            <div class="text-danger text-right clickable font-12 mt-1">
                <span @click="deleteFilter(idx)">
                    Delete
                </span>
            </div>
        </div>
        <div class="mt-2">
            <span @click="addFilter" class="text-purple clickable mt-2">
                Add
            </span>
        </div>
    </div>
</template>

<script>
import {FieldEditorOptionsFilterOperators} from '@/types/document-viewer/field/modules/editor/select/filter'
import {getFormFieldOptions} from '@/types/document-viewer/field/modules/editor/select'
import axios from 'axios'

export default {
    name: 'FieldOptionsFilter',
    props: {
        field: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            options: [],
            isOptionsFetching: false,

            selectFilterOperators: [{
                key: FieldEditorOptionsFilterOperators.EQUAL,
                label: 'Equal'
            }, {
                key: FieldEditorOptionsFilterOperators.NOT_EQUAL,
                label: 'Not equal'
            }, {
                key: FieldEditorOptionsFilterOperators.CONTAINS,
                label: 'Contains'
            }, {
                key: FieldEditorOptionsFilterOperators.NOT_CONTAINS,
                label: 'Not contains'
            }],

            FieldEditorOptionsFilterOperators
        }
    },
    computed: {
        editor() {
            return this.field.editor || {}
        },

        select() {
            return this.editor.select || {}
        },

        filters() { // Array<FieldEditorOptionsFilter>
            return this.select.filters || []
        },

        fields() {
            const fields = []
            this.options.forEach(o => {
                if (!_.isPlainObject(o)) {
                    return
                }
                Object.keys(o).forEach(f => {
                    if (!fields.includes(f) && (_.isString(o[f]) || _.isNumber(o[f]) || _.isBoolean(o[f]))) {
                        fields.push(f)
                    }
                })
            })
            return fields
        }
    },
    methods: {
        addFilter() {
            const filters = _.isArray(this.filters) ? _.cloneDeep(this.filters) : []
            filters.push({
                field: null,
                operator: null,
                value: null
            })
            this.$emit('update', filters)
        },

        deleteFilter(idx) {
            const filters = _.cloneDeep(this.filters)
            filters.splice(idx, 1)
            this.$emit('update', filters)
        },

        onFilterFieldSelect(idx, field) {
            const filters = _.cloneDeep(this.filters)
            filters[idx].field = field
            this.$emit('update', filters)
        },

        onFilterOperatorSelect(idx, operator) {
            const filters = _.cloneDeep(this.filters)
            filters[idx].operator = operator.key
            filters[idx].value = null
            this.$emit('update', filters)
        },

        onFilterValueChange(idx, value) {
            const filters = _.cloneDeep(this.filters)
            filters[idx].value = value
            this.$emit('update', filters)
        },

        async fetchOptions(query = '') {
            this.isOptionsFetching = true
            let data = []
            try {
                ({data} = await getFormFieldOptions({
                    select: this.select,
                    requestId: `${this.field.path}_filter`,
                    filtered: false,
                    params: {
                        q: query,
                        dependencies: this.field.dependants
                    }
                }))
                this.isOptionsFetching = false
            } catch (e) {
                if (!axios.isCancel(e)) {
                    this.isOptionsFetching = false
                }
            } finally {
                this.options = data
            }
        }
    },
    watch: {
        select: {
            handler() {
                this.fetchOptions()
            },
            deep: true,
            immediate: true
        }
    }
}
</script>
